import script from './component-lib.esm21.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 30 30"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'Threads'
  }, _vm.$attrs), false), _vm.$listeners), [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "thrda"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 2.684h22v23.953H4Zm0 0"
    }
  })])]), _c('g', {
    attrs: {
      "clip-path": "url(#thrda)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.824 13.785a24.42 24.42 0 0 0-.312-.14c-.184-3.407-2.047-5.356-5.172-5.38h-.043c-1.867 0-3.422.801-4.379 2.25l1.719 1.18c.715-1.082 1.836-1.316 2.66-1.316h.031c1.027.008 1.805.309 2.309.89.363.426.61 1.012.73 1.754a13.185 13.185 0 0 0-2.953-.144c-2.973.172-4.883 1.906-4.754 4.312.063 1.223.672 2.274 1.711 2.961.879.578 2.012.864 3.191.801 1.551-.086 2.774-.68 3.622-1.765.648-.82 1.054-1.887 1.234-3.235.742.45 1.293 1.035 1.594 1.742.515 1.203.547 3.18-1.067 4.79-1.41 1.41-3.11 2.019-5.672 2.038-2.847-.02-5-.933-6.398-2.71-1.309-1.668-1.988-4.07-2.012-7.153.024-3.078.703-5.484 2.012-7.148 1.398-1.778 3.55-2.692 6.398-2.715 2.864.023 5.055.941 6.508 2.726.711.88 1.246 1.98 1.602 3.266l2.015-.539c-.43-1.582-1.105-2.945-2.023-4.074-1.863-2.293-4.586-3.465-8.098-3.492h-.011c-3.504.027-6.196 1.203-8.008 3.503-1.61 2.047-2.438 4.895-2.465 8.465v.016c.027 3.57.855 6.418 2.465 8.465 1.812 2.3 4.504 3.48 8.008 3.504h.011c3.114-.02 5.309-.836 7.118-2.645 2.367-2.363 2.296-5.324 1.515-7.144-.558-1.301-1.625-2.364-3.086-3.063ZM15.45 18.84c-1.3.074-2.656-.512-2.722-1.762-.047-.93.66-1.965 2.804-2.09.242-.011.485-.02.719-.02.781 0 1.508.075 2.168.22-.246 3.082-1.691 3.582-2.969 3.652Zm0 0"
    }
  })])]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = "data-v-32fa2e48";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var ThreadsIcon = __vue_component__;
export { ThreadsIcon as default };